import { Props as SelectProps } from "react-select";
import { Option } from "@/@types/generics/Option";
import { SelectComponent } from "../SelectComponent";

type Props = SelectProps & {
	label?: string;
};

export const indicatorsEsfOptions: Option<number>[] = [
	{ value: 1, label: "C1 - Mais acesso APS" },
	{ value: 2, label: "C2 - Cuidado no Desenvolvimento Infantil" },
	{ value: 3, label: "C3 - Cuidado da Gestante e Puérpera" },
	{ value: 4, label: "C4 - Cuidado da Pessoa com Diabetes Mellitus" },
	{ value: 5, label: "C5 - Cuidado da Pessoa com Hipertensão" },
	{ value: 6, label: "C6 - Cuidado da Pessoa Idosa" },
	{ value: 7, label: "C7 - Cuidado da Mulher na Prevenção do Câncer" },
];

export function IndicatorsEsfSelect({ label, ...rest }: Props) {
	return (
		<div className="d-flex flex-column">
			<label htmlFor={rest.id} className="form-label">
				{label ?? "Indicadores:"}
			</label>

			<SelectComponent
				id={rest.id}
				placeholder="Selecione..."
				noOptionsMessage={() => "Nenhum nenhum indicador encontrado"}
				options={indicatorsEsfOptions}
				{...rest}
			/>
		</div>
	);
}
